import { createContext } from "react";
import { opportunityInitialState } from "./opportunityInitialState";


const OpportunityContext = createContext(opportunityInitialState)

export default OpportunityContext